import { configureStore } from "@reduxjs/toolkit";

import messageReducer from "../slices/messageSlice.js";
import providerRegistryReducer from "../slices/providerRegistrySlice.js";
import patientReducer from "../slices/patientSlice.js";
import encounterReducer from "../slices/encounterSlice.js";
import configReducer from "../slices/configSlice.js";
import observationReducer from "../slices/observationSlice.js";
import documentReferenceReducer from "../slices/documentReferenceSlice.js"; 
import diagnosticReportReducer from "../slices/diagnosticReportSlice.js"; 
import organizationReducer from "../slices/organizationSlice.js"; 
import careTeamReducer from "../slices/careTeamSlice.js"; 
import mediaReducer from "../slices/mediaSlice.js"; 
import specimenReducer from "../slices/specimenSlice.js"; 
import carePlanReducer from "../slices/carePlanSlice.js"; 
import conditionReducer from "../slices/conditionSlice.js"; 
import serviceRequestReducer from "../slices/serviceRequestSlice.js"; 
import practitionerRoleReducer from "../slices/practitionerRoleSlice.js"; 
import locationReducer from "../slices/locationSlice.js"; 
import questionnaireResponseReducer from "../slices/questionnaireResponseSlice.js"; 
import medicationRequestReducer from "../slices/medicationRequestSlice.js"; 
import immunizationReducer from "../slices/immunizationSlice.js"; 
import medicationReducer from "../slices/medicationSlice.js"; 
import imagingStudyReducer from "../slices/imagingStudySlice.js"; 
import goalReducer from "../slices/goalSlice.js"; 




export const createStore = () =>
  configureStore({
    reducer: {
      messages: messageReducer,
      providers: providerRegistryReducer,
      patients: patientReducer,
      encounters: encounterReducer,
      observations: observationReducer,
      documentReferences: documentReferenceReducer,
      diagnosticReports: diagnosticReportReducer,
      organizations: organizationReducer,
      careTeams: careTeamReducer,
      carePlans: carePlanReducer,
      media: mediaReducer,
      specimens: specimenReducer,
      conditions: conditionReducer,
      serviceRequests: serviceRequestReducer,
      practitionerRoles: practitionerRoleReducer,
      locations: locationReducer,
      questionnaireResponses : questionnaireResponseReducer,
      medicationRequests : medicationRequestReducer,
      immunizations: immunizationReducer,
      medications: medicationReducer,
      imagingStudies: imagingStudyReducer,
      goals: goalReducer,
      config: configReducer,
    },
  });

export default createStore;
